import React from 'react'
import { connect } from 'react-redux'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import $ from 'jquery'
import Moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import LoadingSpinner from './LoadingSpinner'
import ProgressBar from './ProgressBar'

import { clearNoDataError } from '../../GlobalStateContainer/actions'

import {
    fetchInactiveReportList,
    fetchInactiveReportError,
    export_excel_inactive_reports

} from './actions'

import CommError from '../../Shared/Errors/Errors'
import ConfirmModal from '../../Shared/ConfirmModal/ConfirmModal'

import './InactiveReport.css'

var Spinner = require('react-spinkit');

let chkReturn = 0;

class InactiveReport extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sortBy: 'NUMBER',
            sortOrder: 'Ascending',
            startDate: props.inactivereport.report.startDate,
            endDate: props.inactivereport.report.endDate,
            team: null
        };

        this.sortColumn = this.sortColumn.bind(this);

        this.fetchInactiveReportErrorClear = this.fetchInactiveReportErrorClear.bind(this);
        this.errorNoDataClear = this.errorNoDataClear.bind(this);

        this.changeReport = this.changeReport.bind(this);
        this.changeStartDate = this.changeStartDate.bind(this);
        this.changeEndDate = this.changeEndDate.bind(this);
        this.changeTeam = this.changeTeam.bind(this);
        this.inactiveReportExport = this.inactiveReportExport.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.inactivereport.report.startDate !== prevProps.inactivereport.report.startDate) {
            this.setState({
                startDate: this.props.inactivereport.report.startDate
            });
        }

        if (this.props.inactivereport.report.endDate !== prevProps.inactivereport.report.endDate) {
            this.setState({
                endDate: this.props.inactivereport.report.endDate
            });
        }

        if (this.state.startDate !== prevState.startDate
            || this.state.endDate !== prevState.endDate
            || this.state.team !== prevState.team) {
            this.changeReport();
        }
    }

    fetchInactiveReportErrorClear() {
        this.props.dispatch(fetchInactiveReportError);
    }

    errorNoDataClear() {
        this.props.dispatch(clearNoDataError);
    }

    sortColumn(e) {
        if (this.props.inactivereport.fetching) return

        let sortOrder
        let sortElement = e.target.children.length === 0 ? e.target.parentElement : e.target
        let sortBy = sortElement.id
        let sort = sortElement.children[0].className.split(' ')[1]

        if (sort === "fa-sort") {
            sortOrder = "Ascending"
            sortElement.children[0].className = "fa fa-sort-asc fa-xs"
        }
        else if (sort === "fa-sort-asc") {
            sortOrder = "Descending"
            sortElement.children[0].className = "fa fa-sort-desc fa-xs"
        }
        else {
            sortOrder = "Ascending"
            sortElement.children[0].className = "fa fa-sort-asc fa-xs"
        }

        $('th').each(function () {
            if ($(this).attr('id') !== sortElement.id) {
                $(this).removeClass("sort")
                $($(this).children()[0]).removeClass("fa-sort-asc")
                $($(this).children()[0]).removeClass("fa-sort-desc")
                $($(this).children()[0]).addClass("fa-sort")
            }
        })

        sortElement.className = "sort"

        this.setState(
            {
                sortBy: sortBy,
                sortOrder: sortOrder
            }
        )        
    }

    changeStartDate(date) {
        if (this.state.startDate !== date) {
            this.setState({
                startDate: Moment(date).format('YYYY-MM-DD')
            });
        }
    }

    changeEndDate(date) {
        if (this.state.endDate !== date) {
            this.setState({
                endDate: Moment(date).format('YYYY-MM-DD')
            });
        }
    }

    changeTeam(team) {
        this.setState({
            team
        });
    }

    changeReport() {
        var error = false

        let report = {
            team: this.state.team
        };

        if ($('#startDate').val() !== '') {
            $('#startDate').removeClass('error');

            var dte = new Date(this.state.startDate);
            if (dte.getYear() + 1900 >= 2000 &&
                dte.getMonth() >= 0 && dte.getMonth() <= 11 &&
                dte.getDate() >= 0 && dte.getDate() <= 31) {
                report.startDate = this.state.startDate;
            }
            else {
                $('#startDate').addClass('error')
                error = true
            }
        }
        else {
            $('#startDate').addClass('error')
            error = true
        }

        if ($('#endDate').val() !== '') {
            $('#endDate').removeClass('error');

            var dte = new Date(this.state.endDate);
            if (dte.getYear() + 1900 >= 2000 &&
                dte.getMonth() >= 0 && dte.getMonth() <= 11 &&
                dte.getDate() >= 0 && dte.getDate() <= 31) {
                report.endDate = this.state.endDate;
            }
            else {
                $('#endDate').addClass('error')
                error = true
            }
        }
        else {
            $('#endDate').addClass('error')
            error = true
        }

        if (!error) {
            var dte1 = new Date(this.state.startDate);
            var dte2 = new Date(this.state.endDate);

            if (dte1 > dte2) {
                $('#startDate').addClass('error')
                $('#startDate_err').css('display', 'inline')
                error = true
            }
            else {
                $('#startDate_err').css('display', 'none')
            }
        }

        if (error) return

        fetchInactiveReportList.bind(this)(report)
    }

    inactiveReportExport(e) {
        if (this.props.inactivereport.fetching) return

        let inactive_report = {
            startDate: $('#startDate').val(),
            endDate: $('#endDate').val(),
            team: $('#team').val()
        }

        export_excel_inactive_reports(this.props.dispatch, inactive_report, this.turn_off_progress_bar());
    }

    turn_off_progress_bar() {
        document.getElementById("progress_bar").display = "none";
    }

    render() {
        return (
            <div className="inactivereport col-xs-12">
                <CommError error={this.props.inactivereport.error} onClose={this.fetchInactiveReportErrorClear} />

                <ConfirmModal open={this.props.inactivereport.noData} heading={"Inactive Report"} msg={"No Records"} notifyOnly={true} onYes={this.errorNoDataClear} />

                <h1>Inactive Report</h1>

                <div className="row">
                    <div className="col-md-12">
                        <div className="col-md-3">
                            <p>Start Date:</p>
                            <DatePicker
                                id="startDate"
                                onChange={this.changeStartDate}
                                selected={Moment(this.state.startDate).toDate()}
                            />
                        </div>
                        <div className="col-md-3">
                            <p>End Date:</p>
                            <DatePicker
                                id="endDate"
                                onChange={this.changeEndDate}
                                selected={Moment(this.state.endDate).toDate()}
                            />
                        </div>
                        <div className="col-md-3">
                            <p>Select Team:</p>
                            <select id="team" onChange={this.changeTeam}>
                                {
                                    this.props.inactiveReportData.uniqueTeams.map((team, index) => {
                                        return <option key={index} value={team.teamNumber}>{team.teamNumber}-{team.teamName}</option>
                                    })
                                }
                            </select>
                        </div>
                        <div className="col-md-3">
                            <button className="btn btn-primary pull-right" onClick={this.inactiveReportExport}>Export</button>
                            <span id="startExport">
                                {
                                    this.props.inactivereport.complete_export === false ?
                                        <LoadingSpinner />
                                    :
                                        null
                                }
                            </span>
                            <span id="progress_bar"><strong> Export Progress: {this.props.inactivereport.percent_complete}%</strong>
                                <ProgressBar percentage={this.props.inactivereport.percent_complete} />
                            </span>
                        </div>
                    </div>

                    <div className="col-md-12">
                        <div className="tableWrapper">
                            {
                                this.props.inactivereport.fetching ?
                                    <Spinner name='line-spin-fade-loader' />
                                :
                                    null
                            }
                            <table className="lists table table-striped">
                                <thead>
                                    <tr className="head">
                                        <th id="TEAM" onClick={this.sortColumn}>Team #<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="NUMBER" onClick={this.sortColumn}>Customer #<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="ACCOUNT" onClick={this.sortColumn}>Account Type<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="TERRITORY" onClick={this.sortColumn}>Territory #<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="NAME" onClick={this.sortColumn}>Name<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="DATE" onClick={this.sortColumn}>Date<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="CUSTOMER" onClick={this.sortColumn}>Customer Name<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="CURRENT" onClick={this.sortColumn}>Current Status<i className="fa fa-sort fa-xs"></i></th>
                                        <th id="PREVIOUS" onClick={this.sortColumn}>Previous Status<i className="fa fa-sort fa-xs"></i></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.props.inactiveReportData.inactiveReports.sort((a, b) => {
                                            if (this.state.sortBy == "TEAM") {
                                                if (a.team > b.team)
                                                    return this.state.sortOrder == 'Ascending' ? 1 : -1
                                                else if (a.team < b.team)
                                                    return this.state.sortOrder == 'Ascending' ? -1 : 1
                                                else
                                                    return 0
                                            }
                                            else if (this.state.sortBy == "NUMBER") {
                                                if (a.customerNumber > b.customerNumber)
                                                    return this.state.sortOrder == 'Ascending' ? 1 : -1
                                                else if (a.customerNumber < b.customerNumber)
                                                    return this.state.sortOrder == 'Ascending' ? -1 : 1
                                                else
                                                    return 0
                                            } 
                                            else if (this.state.sortBy == "ACCOUNT") {
                                                if (a.accountType > b.accountType)
                                                    return this.state.sortOrder == 'Ascending' ? 1 : -1
                                                else if (a.accountType < b.accountType)
                                                    return this.state.sortOrder == 'Ascending' ? -1 : 1
                                                else
                                                    return 0
                                            } 
                                            else if (this.state.sortBy == "TERRITORY") {
                                                if (a.territoryNumber > b.territoryNumber)
                                                    return this.state.sortOrder == 'Ascending' ? 1 : -1
                                                else if (a.territoryNumber < b.territoryNumber)
                                                    return this.state.sortOrder == 'Ascending' ? -1 : 1
                                                else
                                                    return 0
                                            } 
                                            else if (this.state.sortBy == "NAME") {
                                                if (a.name > b.name)
                                                    return this.state.sortOrder == 'Ascending' ? 1 : -1
                                                else if (a.name < b.name)
                                                    return this.state.sortOrder == 'Ascending' ? -1 : 1
                                                else
                                                    return 0
                                            } 
                                            else if (this.state.sortBy == "DATE") {
                                                if (a.date > b.date)
                                                    return this.state.sortOrder == 'Ascending' ? 1 : -1
                                                else if (a.date < b.date)
                                                    return this.state.sortOrder == 'Ascending' ? -1 : 1
                                                else
                                                    return 0
                                            } 
                                            else if (this.state.sortBy == "CUSTOMER") {
                                                if (a.customerName > b.customerName)
                                                    return this.state.sortOrder == 'Ascending' ? 1 : -1
                                                else if (a.customerName < b.customerName)
                                                    return this.state.sortOrder == 'Ascending' ? -1 : 1
                                                else
                                                    return 0
                                            } 
                                            else if (this.state.sortBy == "CURRENT") {
                                                if (a.currentStatus > b.currentStatus)
                                                    return this.state.sortOrder == 'Ascending' ? 1 : -1
                                                else if (a.currentStatus < b.currentStatus)
                                                    return this.state.sortOrder == 'Ascending' ? -1 : 1
                                                else
                                                    return 0
                                            } 
                                            else {
                                                if (a.previousStatus > b.previousStatus)
                                                    return this.state.sortOrder == 'Ascending' ? 1 : -1
                                                else if (a.previousStatus < b.previousStatus)
                                                    return this.state.sortOrder == 'Ascending' ? -1 : 1
                                                else
                                                    return 0
                                            } 
                                        })
                                        .map((rpt, index) => {
                                            return <tr key={index}>
                                                <td>{rpt.team}</td>
                                                <td>{rpt.customerNumber}</td>
                                                <td>{rpt.accountType}</td>
                                                <td>{rpt.territoryNumber}</td>
                                                <td>{rpt.name}</td>
                                                <td>{rpt.displayDate}</td>
                                                <td>{rpt.customerName}</td>
                                                <td>{rpt.currentStatus}</td>
                                                <td>{rpt.previousStatus}</td>
                                            </tr>
                                        })
                                     }
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="col-md-12">
                        <div className="col-md-3 pull-right">
                            <button className="btn btn-primary pull-right" onClick={this.inactiveReportExport}>Export</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    inactivereport: state.inactivereport
});

export default connect(mapStateToProps)(InactiveReport)
